// tslint:disable:no-console
import * as ReduxObservable from 'redux-observable'
import {ajax} from 'rxjs/ajax'
import {catchError, filter, map, switchMap} from 'rxjs/operators'
import { AjaxWrapper } from '../generic/ajaxWrapper'
import * as Router from '../router'
import { getStorage, STORAGE_KEYS } from '../storage/utils'
import * as Constants from './constants'
import { sendToLogin } from './utils'

const BASE_ROUTE = '/'
const ALL_METADATA = 'ALL_METADATA'
const validateToken = (action$, state$, {history}) =>
  action$
    .ofType(Router.ON_ENTER)
    .pipe(
      filter(() => getStorage(STORAGE_KEYS.RASA_AUTH_TOKEN) !== '' && history.location.pathname !== BASE_ROUTE),
      map(() => getStorage(STORAGE_KEYS.RASA_AUTH_TOKEN)),
      switchMap((authToken: string) =>
        ajax({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + authToken,
          },
          method: 'get',
          url: state$.value.config.api + '/auth/token',
        }).pipe(
          map((payload) => {
            AjaxWrapper.setToken(authToken)
            return {type: Constants.VALID_TOKEN}
          }),
          catchError((error) => {
            sendToLogin()
            console.error('token error', error)
            return []
          }))))

const bypassValidation = (action$, state$, {history}) =>
  action$
  .ofType(ALL_METADATA)
  .pipe(
    filter(() => history.location.pathname === BASE_ROUTE),
    map(() => ({type: 'UNAUTHENTICATED'})),
  )

export const epic = ReduxObservable.combineEpics(bypassValidation, validateToken)
